import { gql } from '@apollo/client'

import { useMutation } from 'hooks'

const FORM_PUBLISH_MUTATION = gql`
  mutation FormPublish($formId: Long!) {
    formPublish(id: $formId) {
      id
      status
      errors {
        message
      }
    }
  }
`

export const useFormPublishMutation = (formId, opts) =>
  useMutation(FORM_PUBLISH_MUTATION, opts, { formId })
